export type SWConfig = {
  onSuccess?: (reg: ServiceWorkerRegistration) => void
  onUpdate?: (reg: ServiceWorkerRegistration) => void
}

export function register(config?: SWConfig) {
  if (!("serviceWorker" in navigator)) return

  window.addEventListener("load", () => {
    const swUrl = "/service-worker.js" // in /public

    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        // console.log("[SW] registered", reg)

        reg.onupdatefound = () => {
          const worker = reg.installing
          if (!worker) return

          worker.onstatechange = () => {
            if (worker.state === "installed") {
              if (navigator.serviceWorker.controller) {
                console.log("[SW] update available")
                config?.onUpdate?.(reg)
              } else {
                console.log("[SW] content cached")
                config?.onSuccess?.(reg)
              }
            }
          }
        }
      })
      .catch((err) => console.error("[SW] registration error:", err))
  })
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((reg) => reg.unregister())
  }
}
